// Implementação do provedor Chat360
import { WhatsAppProviderBase } from '../WhatsAppProviderBase';
import { whatsappTemplates } from '../../templates/whatsappTemplates';

export class Chat360Provider extends WhatsAppProviderBase {
  constructor(config) {
    super(config);
    this.apiBaseUrl = config.apiBaseUrl;
    this.instance = config.instance;
    this.apiToken = config.apiToken;
  }

  async sendTemplate(template, params, to) {
    const coremsg = whatsappTemplates[template](params);
    const finalmsg = whatsappTemplates.baseTemplate(coremsg.content);

    return this.send({
      to: to,
      message: finalmsg
    });
  }

  async send(payload) {
    try {
      const endpoint = `${this.apiBaseUrl}/${this.instance}`;
      
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.apiToken
        },
        body: JSON.stringify({
          number: `+55${payload.to}`,
          body: payload.message,
          externalKey: 1
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Erro na API do Chat360:', errorData);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Erro ao enviar mensagem via Chat360:', error);
      return false;
    }
  }
}